import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { login } from '../../store/actions/app.actions';
import { Router } from '@angular/router';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { ContentComponent } from '../../components/content/content.component';
import { SessionService } from '../../services/ssession.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-obtain-token-page',
  standalone: true,
  imports: [
    ContentComponent,
    SpinnerComponent
  ],
  template: '<app-content> <section style="text-align: center"><app-spinner></app-spinner></section> </app-content>',
  styles: ''
})
export class ObtainTokenPageComponent {
  constructor(
    private store$: Store,
    private router: Router
  ) {
    this.onLogin();
  }

  public onLogin(): void {
    if (!environment.production) {
      this.store$.dispatch(
        login({
          payload: { username: '11111111116', password: 'tester' },
          successFnc: () => {
            if (SessionService.IsCompletedUserData()) {
              this.router.navigate(['/strona-glowna']);
            } else {
              this.router.navigate(['/moje-dane']);
            }
          },
          failureFnc: () => {
            this.router.navigate(['/strona-glowna']);
          }
        })
      );
    }
  }
}
